module.exports = __webpack_public_path__ + "media/images/service-3-5d726a8c94b664b4f08ee7297ff7b2a4.png";